import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/:prefix?', // 可选动态前缀参数
      component: () => import('@/views/layout'),
      children: [
        {
          path: 'Crowdfunding',
          name: 'Crowdfunding',
          component: () => import('@/views/layout/Crowdfunding'),
          meta: { keepAlive: true }
        },
        {
          path: 'Country',
          name: 'Country',
          component: () => import('@/views/layout/Country'),
          meta: { keepAlive: true }
        },
        {
          path: 'home',
          name: 'Home',
          component: () => import('@/views/layout/home'),
          meta: { keepAlive: true }
        },
        {
          path: 'appDetail',
          name: 'AppDetail',
          component: () => import('@/views/layout/appDetail'),
          meta: { keepAlive: false }
        },
        {
          path: 'menu',
          name: 'Menu',
          component: () => import('@/views/layout/menu'),
          meta: { keepAlive: true }
        },
        {
          path: 'Support',
          name: 'Support',
          component: () => import('@/views/layout/Support'),
          meta: { keepAlive: true }
        },
        {
          path: 'bonus',
          name: 'Bonus',
          component: () => import('@/views/layout/bonus'),
          meta: { keepAlive: true }
        },
        {
          path: 'lottery',
          name: 'Lottery',
          component: () => import('@/views/layout/lottery'),
          meta: { keepAlive: true }
        },
        {
          path: 'share',
          name: 'Share',
          component: () => import('@/views/layout/share'),
          meta: { keepAlive: true }
        },
        {
          path: 'mine',
          name: 'Mine',
          component: () => import('@/views/layout/mine'),
          meta: { keepAlive: true }
        },
        {
          path: 'activity',
          name: 'Activity',
          component: () => import('@/views/layout/activity'),
          meta: { keepAlive: true }
        },
        {
          path: 'rechargeCont',
          name: 'RechargeCont',
          component: () => import('@/views/layout/rechargeCont')
        },
        {
          path: 'firstDepositGift',
          name: 'FirstDepositGift',
          component: () => import('@/views/details/activity/firstDepositGift')
        },
        {
          path: 'newbieGift',
          name: 'NewbieGift',
          component: () => import('@/views/details/activity/newbieGift')
        }
      ]
    },
    // 独立路由前缀支持
    {
      path: '/:prefix?/activityFistRecharge',
      name: 'ActivityFistRecharge',
      component: () => import('@/views/details/bonus/activityFistRecharge')
    },
    {
      path: '/:prefix?/activityRecharge',
      name: 'ActivityRecharge',
      component: () => import('@/views/details/bonus/activityRecharge')
    },
    {
      path: '/:prefix?/activityCooperate',
      name: 'ActivityCooperate',
      component: () => import('@/views/details/bonus/activityCooperate')
    },
    {
      path: '/:prefix?/cashBack',
      name: 'CashBack',
      component: () => import('@/views/details/bonus/cashBack')
    },
    {
      path: '/:prefix?/teamRebates',
      name: 'TeamRebates',
      component: () => import('@/views/details/bonus/teamRebates')
    },
    {
      path: '/:prefix?/redPacket',
      name: 'RedPacket',
      component: () => import('@/views/details/bonus/redPacket')
    },
    {
      path: '/:prefix?/signIn',
      name: 'SignIn',
      component: () => import('@/views/details/bonus/signIn')
    },
    {
      path: '/:prefix?/dailyCheckIn',
      name: 'DailyCheckIn',
      component: () => import('@/views/details/activity/dailyCheckIn')
    },
    {
      path: '/:prefix?/rewardHistory',
      name: 'RewardHistory',
      component: () => import('@/views/details/activity/rewardHistory')
    },
    {
      path: '/:prefix?/seasonPass',
      name: 'SeasonPass',
      component: () => import('@/views/details/activity/seasonPass')
    },
    {
      path: '/:prefix?/seasonHistory',
      name: 'SeasonHistory',
      component: () => import('@/views/details/activity/seasonHistory')
    },
    {
      path: '/:prefix?/weeklyMissions',
      name: 'WeeklyMissions',
      component: () => import('@/views/details/activity/weeklyMissions')
    },
    {
      path: '/:prefix?/luckyReferral',
      name: 'LuckyReferral',
      component: () => import('@/views/details/activity/luckyReferral')
    },
    {
      path: '/:prefix?/referFriend',
      name: 'ReferFriend',
      component: () => import('@/views/details/bonus/referFriend')
    },
    {
      path: '/:prefix?/bankAdd',
      name: 'BankAdd',
      component: () => import('@/views/details/recharge/bankAdd')
    },
    {
      path: '/:prefix?/authName',
      name: 'AuthName',
      component: () => import('@/views/details/recharge/authName')
    },
    {
      path: '/:prefix?/setPassWord',
      name: 'SetPassWord',
      component: () => import('@/views/details/recharge/setPassWord')
    },
    {
      path: '/:prefix?/Alliance',
      name: 'Alliance',
      component: () => import('@/views/details/mine/Alliance')
    },
    {
      path: '/:prefix?/vip',
      name: 'Vip',
      component: () => import('@/views/details/mine/vip')
    },
    {
      path: '/:prefix?/profile',
      name: 'Profile',
      component: () => import('@/views/details/mine/profile')
    },
    {
      path: '/:prefix?/passwordLogin',
      name: 'PsswordLogin',
      component: () => import('@/views/details/mine/passwordLogin')
    },
    {
      path: '/:prefix?/bank',
      name: 'Bank',
      component: () => import('@/views/details/mine/bank')
    },
    {
      path: '/:prefix?/avatar',
      name: 'Avatar',
      component: () => import('@/views/details/mine/avatar')
    },
    {
      path: '/:prefix?/privacy',
      name: 'Privacy',
      component: () => import('@/views/details/mine/privacy')
    },
    {
      path: '/:prefix?/billGame',
      name: 'BillGame',
      component: () => import('@/views/details/mine/billGame')
    },
    {
      path: '/:prefix?/gameHall',
      name: 'GameHall',
      component: () => import('@/views/details/mine/gameHall')
    },
    {
      path: '/:prefix?/payOrder',
      name: 'PayOrder',
      component: () => import('@/views/details/mine/payOrder')
    },
    {
      path: '/:prefix?/joinUs',
      name: 'JoinUs',
      component: () => import('@/views/details/bonus/joinUs')
    },
    {
      path: '/:prefix?/recordOrder',
      name: 'RecordOrder',
      component: () => import('@/views/details/recharge/recordOrder')
    },
    {
      path: '/:prefix?/orderDetail',
      name: 'OrderDetail',
      component: () => import('@/views/details/recharge/orderDetail')
    },
    {
      path: '/:prefix?/firstRegister',
      name: 'FirstRegister',
      component: () => import('@/views/details/bonus/firstRegister')
    },
    {
      path: '/:prefix?/cp',
      name: 'Cp',
      component: () => import('@/views/details/mine/cp')
    },
    {
      path: '/:prefix?/email',
      name: 'Email',
      component: () => import('@/views/details/mine/email')
    },
    {
      path: '/:prefix?/myCollection',
      name: 'MyCollection',
      component: () => import('@/views/details/mine/myCollection')
    },
    {
      path: '/:prefix?/category',
      name: 'Category',
      component: () => import('@/views/details/home/category')
    },
    {
      path: '/:prefix?/messageCenter',
      name: 'MessageCenter',
      component: () => import('@/views/details/home/messageCenter')
    },
    {
      path: '/:prefix?/searchGame',
      name: 'SearchGame',
      component: () => import('@/views/details/home/searchGame')
    },
    {
      path: '/:prefix?/gameDetail',
      name: 'GameDetail',
      component: () => import('@/views/details/home/gameDetail')
    },
    {
      path: '/:prefix?/lotteryDetail',
      name: 'LotteryDetail',
      component: () => import('@/views/details/lottery/lotteryDetail')
    },
    {
      path: '/:prefix?/betHistory',
      name: 'BetHistory',
      component: () => import('@/views/details/lottery/betHistory')
    },
    {
      path: '/:prefix?/latestResults',
      name: 'LatestResults',
      component: () => import('@/views/details/lottery/latestResults')
    },
    {
      path: '/:prefix?/bettingDetails',
      name: 'BettingDetails',
      component: () => import('@/views/details/lottery/bettingDetails')
    },
    {
      path: '/:prefix?/settings',
      name: 'Settings',
      component: () => import('@/views/details/mine/settings')
    },
    {
      path: '/:prefix?/editProfile',
      name: 'EditProfile',
      component: () => import('@/views/details/mine/editProfile')
    },
    {
      path: '/:prefix?/vipLevels',
      name: 'VipLevels',
      component: () => import('@/views/details/mine/vipLevels')
    },
    {
      path: '/:prefix?/passwordSuccess',
      name: 'PasswordSuccess',
      component: () => import('@/views/details/mine/passwordSuccess')
    },
    {
      path: '/:prefix?/transactionRecords',
      name: 'TransactionRecords',
      component: () => import('@/views/details/mine/transactionRecords')
    },
    {
      path: '/:prefix?/phoneUnbound',
      name: 'PhoneUnbound',
      component: () => import('@/views/details/mine/phoneUnbound')
    },
    {
      path: '/:prefix?/googlePhoneBind',
      name: 'GooglePhoneBind',
      component: () => import('@/views/details/mine/googlePhoneBind')
    }
  ]
})

// 全局前置守卫 - 核心逻辑：
// 1. 强制同步URL前缀与本地country
// 2. / 跳 /Country，/xx 跳 /xx/home（并刷新页面）
router.beforeEach((to, from, next) => {
  // Google OAuth callback: save code before redirects strip it
  // Google OAuth callback: if URL has code param, let App.vue handle it — do NOT redirect
  const urlSearch = new URLSearchParams(window.location.search)
  const rawCode = to.query.code || urlSearch.get('code')
  if (rawCode) {
    console.log('[Google OAuth] Router guard: Google callback detected, letting App.vue handle it')
    return next()
  }

  const defaultCountry = 'NG'
  const savedCountry = localStorage.getItem('country') // 本地存储的前缀
  const routePrefix = to.params.prefix // URL中的前缀
  const pathSegments = to.path.split('/').filter(Boolean)

  // appDetail 是页面路径，不是国家前缀；兼容 /appDetail 和旧错误路径 /appDetail/appDetail
  if (pathSegments[0] === 'appDetail') {
    localStorage.setItem('country', defaultCountry)
    const childPath = pathSegments[1] || 'appDetail'
    return next({
      path: `/${defaultCountry}/${childPath}`,
      query: to.query,
      hash: to.hash,
      replace: true
    })
  }

  let finalPrefix = ''

  // 1. 前缀同步逻辑（保持原有规则）
  if (savedCountry) {
    finalPrefix = savedCountry
    // 如果URL前缀和本地不一致，强制重定向到本地前缀的URL
    if (routePrefix !== savedCountry) {
      const pathWithoutPrefix = to.path.replace(/^\/[^/]+/, '') || ''
      const correctPath = `/${savedCountry}${pathWithoutPrefix}`
      // Google OAuth callback: use full page reload so App.vue re-mounts and processes the code
      if (localStorage.getItem('googleAuthCode')) {
        window.location.href = correctPath
        return
      }
      return next(correctPath)
    }
  } else {
    // 本地无值：用URL前缀并存储到本地
    finalPrefix = routePrefix || ''
    if (finalPrefix) {
      localStorage.setItem('country', finalPrefix)
    }
  }

  // 2. 核心重定向规则：/ 跳 /Country，/xx 跳 /xx/home（带刷新）
  // 分割路径并过滤空值，得到有效路径段数组
  // 已定义的合法子路由列表（避免对已定义路由重复重定向）
  const validSubPaths = [
    'Crowdfunding',
    'Country',
    'home',
    'appDetail',
    'menu',
    'Support',
    'bonus',
    'lottery',
    'share',
    'mine',
    'activity'
  ]

  // 场景1：访问纯根路径 / → 跳 /Country
  if (pathSegments.length === 0) {
    // Google OAuth callback at root: need full reload for App.vue to process code
    if (localStorage.getItem('googleAuthCode') && savedCountry) {
      window.location.href = `/${savedCountry}/home`
      return
    }
    return next('/Country')
  }
  // 场景2：访问纯前缀路径 /xx（无任何子路径）→ 跳 /xx/home 并刷新页面
  else if (
    pathSegments.length === 1 &&
    !validSubPaths.includes(pathSegments[0])
  ) {
    const prefix = pathSegments[0]
    // 存储前缀到本地
    localStorage.setItem('country', prefix)
    const targetPath = `/${prefix}/home`
    // 关键修改：使用window.location.href触发页面刷新，而非next()
    window.location.href = targetPath
    // 终止后续逻辑执行
    return
  }

  // 3. 原有权限验证逻辑（保持不变）
  const needAuthPaths = ['/rechargeCont', '/mine', '/share']
  const currentPath = to.path.replace(/^\/[^/]+/, '') || '/'

  if (needAuthPaths.includes(currentPath)) {
    const token = localStorage.getItem('token')
    if (!token) {
      const redirectPath = finalPrefix ? `/${finalPrefix}/home` : '/home'
      if (!from.fullPath) {
        next(redirectPath)
      } else {
        setTimeout(() => {
          next(redirectPath)
        }, 0)
      }
      return
    }
  }

  // 合法路由直接放行
  next()
})

export default router
